import React from "react";
import TemplatePart from "./TemplatePart";
import ITemplatePart from "../../../../interfaces/DynamicCampaigns/ITemplatePart";

const Headline: React.FC<ITemplatePart> = (props) => {
    return <TemplatePart {...props} size="w-1/2" />;
};

export default Headline;
